// extracted by mini-css-extract-plugin
export var avatarContainer = "_9a-0";
export var avatarTypingWave = "_9a-i";
export var gray = "_9a-f";
export var green = "_9a-c";
export var icon = "_9a-9";
export var image = "_9a-1";
export var lg = "_9a-6";
export var md = "_9a-5";
export var presenceDot = "_9a-b";
export var red = "_9a-d";
export var sm = "_9a-4";
export var status = "_9a-a";
export var typingDot = "_9a-h";
export var typingPill = "_9a-g";
export var xl = "_9a-7";
export var xs = "_9a-3";
export var xxl = "_9a-8";
export var xxs = "_9a-2";
export var yellow = "_9a-e";